export const calculateImageSize = (size: number) => {
    return Math.round(size * devicePixelRatio)
};
